import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import Meta from 'vue-meta'

import 'swiper/dist/css/swiper.css'
import '@/css/common.scss'
import '@/css/iconfont.css'

Vue.config.productionTip = false

Vue.use(VueAwesomeSwiper, /* { default global options } */)
Vue.use(Meta)

Vue.mixin({
  data () {
    return {
      publicPath: process.env.NODE_ENV === 'production'
      ? '/staticpage/job/'
      : '/'
    }
  }
})

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
